import React from 'react';

const faqs = [
  {
    question: "What makes a good acronym?",
    answer: "A good acronym should be memorable, meaningful, and easy to pronounce. It should effectively represent your organization or concept while being simple enough for people to remember and use."
  },
  {
    question: "How do you create a meaningful acronym?",
    answer: "To create a meaningful acronym, start with the key concepts you want to convey, then find words that both start with your desired letters and relate to your message. Our generator helps by suggesting relevant words and combinations."
  },
  {
    question: "What are popular uses for acronyms?",
    answer: "Acronyms are commonly used for organization names, project titles, product names, educational concepts, and memorable phrases. They help simplify complex terms and create memorable branding."
  },
  {
    question: "Should my acronym be simple or creative?",
    answer: "This depends on your purpose. Professional organizations might prefer simpler, straightforward acronyms, while creative projects might benefit from more playful ones. Consider your audience and usage context."
  },
  {
    question: "Can I use my generated acronym commercially?",
    answer: "Yes, the acronyms generated are free to use. However, we recommend checking for existing trademarks if you plan to use the acronym commercially."
  },
  {
    question: "How often are new options added to the generator?",
    answer: "Our AI system continuously learns from current trends and user preferences to expand its word database and generation capabilities, ensuring fresh and relevant suggestions."
  }
];

export default function AcronymFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Acronym Generator FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-blue-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}